import styled from 'styled-components';
import { InterestedBoxStyled } from '../InterestedBoxStyled';
import { rem } from 'polished';

export const InterestedBoxStyledAC = styled(InterestedBoxStyled)`
    margin-left: ${rem(10)};
    margin-right: ${rem(10)};
    width: auto;

    .reinsurance,
    .dealerShare {
        color: ${({ theme }) => theme.colors.grey5};
        border-bottom: 1px solid ${({ theme }) => theme.colors.grey5};
    }

    .dealerShare {
        &:hover,
        &:focus-visible {
            color: ${({ theme }) => theme.colors.red};
            border-color: ${({ theme }) => theme.colors.red};
        }
    }

    .clearfix {
        margin-top: ${rem('10px')};
    }

    .links-section {
        a {
            font-size: ${({ theme }) => theme.fontSizes.h5};
        }
    }
`;
